/* eslint-disable react/prop-types */
import React from 'react'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import ListSubheader from '@mui/material/ListSubheader'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import PropTypes from 'prop-types'
import * as constants from '../../common/constants'
import { useTranslation } from 'react-i18next'

export const GroupedAssetType = (props) => {
  const { label, assetTypes, onChange, value, dropDownWidth } = props
  const width = dropDownWidth || constants.ITEM_WIDTH
  const { t } = useTranslation()
  const renderAssetTypes = () => {
    const menuItems = []
    Object.values(assetTypes).forEach((assetType) => {
      if (assetType.isActive) {
        menuItems.push(
          <ListSubheader key={assetType.name}>{t(`dropdowns.${assetType.name}`)}</ListSubheader>,
          ...renderSubAssetTypes(assetType.subAssetTypes)
        )
      }
    })
    return menuItems
  }

  const renderSubAssetTypes = (subAssetTypes) => {
    return Object.values(subAssetTypes).map((subAssetType) => {
      if (subAssetType.isActive) {
        return (
          <MenuItem key={subAssetType.name} value={subAssetType.name}>
            {t(`dropdowns.${subAssetType.name}`)}
          </MenuItem>
        )
      }
      return null
    })
  }

  return (
    <div>
      <FormControl sx={{ m: 1, width: width }} size={'small'}>
        <InputLabel sx={{ backgroundColor: 'white', padding: '0 4px' }}>
          {label}
        </InputLabel>
        <Select value={value} onChange={onChange} label='Grouping'>
          <MenuItem value=''>
            <em>{constants.defaultSelect}</em>
          </MenuItem>
          {renderAssetTypes()}
        </Select>
      </FormControl>
    </div>
  )
}

GroupedAssetType.propTypes = {
  label: PropTypes.string,
  assetTypes: PropTypes.object,
}
export default GroupedAssetType
